'use strict';
Odigeo.defineWidget('share_itinerary', Odigeo.Widget.extend({
    modelClass: require('./share_itinerary.model'),
    viewClass: require('./share_itinerary.view'),
}));
